'use strict';

require('../modules/forms/forms');
require('./themes/customPartner/customPartner');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.partnerFromUserForm', ['dekky.forms', 'dekky.forms.themes.customPartner', 'far.helpers.showModalMessage'])
.service('partnerFromUserForm', function(form, showModalMessage) {
	var customPartnerModel = form('partnerFromUserForm', {
		theme: '/dekky.forms/themes/customPartner'
	});

	customPartnerModel
		.addField('name', null, {
			validators: {
				required: true
			},
			options: {
				placeholder: 'Название',
				class: 'form__item width-250'
			}
		})
		.addField('url', 'url', {
			validators: {
				required: true
			},
			options: {
				placeholder: 'Ссылка',
				class: 'form__item width-250'
			}
		})
		.addField('logo', 'imageUpload', {
			validators: {
				required: true
			},
			label: 'Загрузить логотип',
			uploader: {
				url: Routing.generate('api_upload_post_image'),
				autoUpload: true,
				personalUploader: true,
				onAfterAddingFile: function(item) {
					this.queue.length = 0;
					this.queue.push(item);
				},
				onSuccessItem: function (item, response) {
					item.serverData = response;
				}
			}
		});

	return customPartnerModel;
});
